import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { IonicStorageModule } from '@ionic/storage';
import { Network } from '@ionic-native/network';
import { Keyboard } from '@ionic-native/keyboard';
import { EmailComposer } from '@ionic-native/email-composer';
import { File } from '@ionic-native/file';
import { DecimalPipe } from '@angular/common';
import { Geolocation } from '@ionic-native/geolocation';
import { ChartsModule } from 'ng2-charts'; 
import { ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule  } from '@angular/common/http';
// import { InAppBrowser } from '@ionic-native/in-app-browser';

import { MyApp } from './app.component';
import { AcessoServiceProvider } from '../providers/acesso-service';
import { LoginServiceProvider } from '../providers/login-service';
import { RedditServiceProvider } from '../providers/reddit-service';
import { GlobalServiceProvider } from '../providers/global-service';
import { ImpostosServiceProvider } from '../providers/impostos-service';
import { SincronizarServiceProvider } from '../providers/sincronizar-service';
import { DatabaseServiceProvider } from '../providers/database-service';

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot(),
    ChartsModule,    
    ReactiveFormsModule,
    HttpClientModule 
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    Network,
    Keyboard,
    EmailComposer,
    File,
    DecimalPipe,
    AcessoServiceProvider,
    LoginServiceProvider,
    RedditServiceProvider,
    GlobalServiceProvider,
    ImpostosServiceProvider,
    SincronizarServiceProvider,
    DatabaseServiceProvider,
    Geolocation
  ]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./src/app/app.module.ts